'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mediaService = require('../../../common/media/mediaService');

var _mediaService2 = _interopRequireDefault(_mediaService);

var _getClientConfig = require('../getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientConfig = (0, _getClientConfig2.default)();

exports.default = (0, _mediaService2.default)(clientConfig.mediaServer.apiUrl);


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/mediaService.js
// module id = 315
// module chunks = 0